import { IStyle } from '@fluentui/react';
import { FontSizes, FontWeights, IH2OTheme, Sizes } from '@h2oai/ui-kit';

export interface IDetailHeaderStyles {
  root: IStyle;
  thumbnail: IStyle;
  body: IStyle;
  description: IStyle;
  fields: IStyle;
  field: IStyle;
  fieldTitle: IStyle;
  fieldValue: IStyle;
  owners: IStyle;
  owner: IStyle;
  ownerName: IStyle;
  calloutHeader: IStyle;
  calloutContents: IStyle;
}

export interface IDetailHeaderClassNames {
  root: string;
  body: string;
  thumbnail: string;
  description: string;
  fields: string;
  field: string;
  fieldTitle: string;
  fieldValue: string;
  owners: string;
  owner: string;
  ownerName: string;
  calloutHeader: string;
  calloutContents: string;
}

export const detailHeaderStylesDefault = (theme: IH2OTheme): Partial<IDetailHeaderStyles> => ({
  root: {
    display: 'flex',
    padding: '16px',
    backgroundColor: theme.palette?.white,
    borderRadius: Sizes.borderRadius,
    marginBottom: Sizes.padding,
    '&.is-collapsed': {
      '.h2o-DetailHeader-thumbnail': {
        width: '50px',
        height: '50px',
      },
      '.h2o-DetailHeader-description, .field-title-latest-update, .field-title-created': {
        height: '0px',
        marginBottom: '0px',
      },
      '.h2o-DetailHeader-body': {
        overflow: 'auto',
      },
    },
  },
  thumbnail: {
    width: '100px',
    height: '100px',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    overflow: 'hidden',
    borderRadius: Sizes.borderRadius,
    marginRight: '24px',
    transitionProperty: 'width, height',
    transitionDuration: '300ms',
  },
  body: { flex: 1, minWidth: 0, marginRight: 24 },
  description: {
    height: '44px',
    overflow: 'auto',
    marginBottom: '10px',
    transitionProperty: 'height',
    transitionDuration: '300ms',
    flex: 1,
  },
  fields: { display: 'flex', overflowX: 'auto', overflowY: 'visible', gap: '24px' },
  field: {},
  fieldTitle: { whiteSpace: 'noWrap' },
  fieldValue: {
    whiteSpace: 'noWrap',
    fontSize: FontSizes.xxsmall,
    fontWeight: FontWeights.semiBold,
    lineHeight: '24px',
  },
  owners: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, auto)',
    lineHeight: '25px',
    marginRight: '-8px',
    marginTop: '8px',
  },
  owner: {
    display: 'contents',
  },
  ownerName: {
    paddingRight: Sizes.padding,
    fontWeight: FontWeights.semiBold,
  },
  calloutHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    span: {
      fontWeight: FontWeights.semiBold,
    },
  },
});
